import { FeedBackType } from "../Types/ui-feedback.types";

export class FeedBackHelper {

    static isSuccess = (type: FeedBackType) => type === FeedBackType.SUCCESS;

    static isError = (type: FeedBackType) => type === FeedBackType.ERROR;

    static isInfo = (type: FeedBackType) => type === FeedBackType.INFO;

    static isDefault = (type: FeedBackType) => type === FeedBackType.DEFAULT;

    static isSystem = (type: FeedBackType) => type === FeedBackType.SYSTEM;

    static isAchievement = (type: FeedBackType) => type === FeedBackType.ACHIEVEMENT;

    static isWarning = (type: FeedBackType) => type === FeedBackType.WARNING;

    static is = (type: FeedBackType, expected: FeedBackType) => type === expected;
}